var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPool(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 16.618V16.618C4.146 16.109 5.454 16.109 6.6 16.618V16.618C7.746 17.127 9.054 17.127 10.2 16.618V16.618C11.346 16.109 12.654 16.109 13.8 16.618V16.618C14.946 17.127 16.254 17.127 17.4 16.618V16.618C18.546 16.109 19.854 16.109 21 16.618V16.618",
    stroke: "black",
    strokeWidth: 1.15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 8H16",
    stroke: "black",
    strokeWidth: 1.15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8 12H16",
    stroke: "black",
    strokeWidth: 1.15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16 14V4.5C16 3.672 16.672 3 17.5 3V3C18.328 3 19 3.672 19 4.5",
    stroke: "black",
    strokeWidth: 1.15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8 14V4.5C8 3.672 8.672 3 9.5 3V3C10.328 3 11 3.672 11 4.5",
    stroke: "black",
    strokeWidth: 1.15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M3 20.618V20.618C4.146 20.109 5.454 20.109 6.6 20.618V20.618C7.746 21.127 9.054 21.127 10.2 20.618V20.618C11.346 20.109 12.654 20.109 13.8 20.618V20.618C14.946 21.127 16.254 21.127 17.4 20.618V20.618C18.546 20.109 19.854 20.109 21 20.618V20.618",
    stroke: "black",
    strokeWidth: 1.15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPool);
export default __webpack_public_path__ + "static/media/pool.58e9484c52bcb6384d8566ed6833201c.svg";
export { ForwardRef as ReactComponent };